import React from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { Box, Button, FormControl, Input, InputLabel, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import clsx from "clsx";
import { isLogin } from "src/app-redux/auth/authSlice";
import { useAppSelector } from "src/app-redux/hooks";
import NJSLogo from "src/assets/images/tfg_mainlogo.svg";
import AddTitleToBroswerTab from "src/components/molecules/AddTitleToBroswerTab";
import { WorkOrderRoute } from "src/modules/work-order/workorder.routes";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    loginButton: {
      backgroundColor: "#72CA00 !important",
      color: "#ffffff",
      width: "100%",
      marginTop: "100px",
      fontSize: "12px",
      textTransform: "unset",
      boxShadow: "none",
    },
    textFieldsRow: {
      margin: "5px 0 20px",
      boxShadow: "0px 1px 2px 0px rgba(0,0,0,6%)",
    },
    textInput: {
      height: "32px",
      padding: "0 8px",
      color: "#A3A3A3",
      fontSize: "12px",
      border: "1px solid #E6E6E6",
      borderRadius: "4px",
      letterSpacing: "0.16px",
    },
    inputLabel: {
      padding: "0 0 10px",
      color: "#292929",
      fontSize: "12px",
      letterSpacing: "0.16px",
    },
    footNote: {
      fontSize: "12px",
      color: "#96A4B9",
    },
    headerLogo: {
      textAlign: "center",
    },
    headerLogoLink: {
      textAlign: "center",
      width: "100%",
      float: "left",
    },
    // margin: {
    //   margin: theme.spacing(1),
    // },
    // withoutLabel: {
    //   marginTop: theme.spacing(3),
    // },
    // textField: {
    //   width: "25ch",
    // },
  })
);

interface State {
  password: string;
  showPassword: boolean;
}
export function RegisterPage() {
  const history = useHistory();
  const user = useAppSelector(isLogin);
  const classes = useStyles();
  const [values, setValues] = React.useState<State>({
    password: "",
    showPassword: false,
  });
  const handleChange = (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  return user ? (
    <Redirect to={{ pathname: WorkOrderRoute.path }} />
  ) : (
    <div className="register-page">
      <AddTitleToBroswerTab title={"TFG | Portal | Registration"} />
      <div className="left-section">
        <div className="inner">
          <Box my={2} className="headerLogo" textAlign="center">
            <a href="/" className="headerLogoLink">
              <img src={NJSLogo} alt="logo" width="200" />
            </a>
          </Box>
          <div className="form-wrapper">
            <h2 className="form-heading">Create a new account</h2>
            <InputLabel className={clsx(classes.inputLabel)} htmlFor="my-input">
              Email address
            </InputLabel>
            <FormControl className={`MuiFormControl-fullWidth ${clsx(classes.textFieldsRow)}`}>
              <Input
                placeholder="myemail@address.com"
                className={clsx(classes.textInput)}
                disableUnderline={true}
              />
            </FormControl>
            <InputLabel className={clsx(classes.inputLabel)} htmlFor="standard-adornment-password">
              Password
            </InputLabel>
            <FormControl className={`MuiFormControl-fullWidth ${clsx(classes.textFieldsRow)}`}>
              <Input
                id="standard-adornment-password"
                className={clsx(classes.textInput)}
                type={values.showPassword ? "text" : "password"}
                value={values.password}
                onChange={handleChange("password")}
                disableUnderline={true}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      size="large"
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Button
              variant="contained"
              className={clsx(classes.loginButton)}
              onClick={() => {
                localStorage.setItem("TOKEN", "auth");
                history.push(WorkOrderRoute.path);
              }}
            >
              Register
            </Button>
            <Button component={Link} to="/auth/login">
              Back to Login
            </Button>
          </div>
          <Typography
            component="span"
            variant="body1"
            color="textPrimary"
            className={clsx(classes.footNote)}
          >
            Copyright©, The Facilities Group, {new Date().getFullYear()}
          </Typography>
        </div>
      </div>
      <div className="right-section">
        <div className="login-bg-pattern"></div>
      </div>
    </div>
  );
}
